import ViewOff16 from '@carbon/icons-react/es/view--off/16';
import View16 from '@carbon/icons-react/es/view/16';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { ActionBar } from 'components/molecules/action-bar';

export const CommentRichTextActionBar: FC<{
  isPrivate: boolean;
  rte;
}> = ({ isPrivate, rte }) => (
  <ActionBar private={isPrivate}>
    <ActionBar.Primary>
      <Button
        type="text"
        icon={isPrivate ? <ViewOff16 /> : <View16 />}
        disabled
      />
    </ActionBar.Primary>
    <ActionBar.Secondary>
      <RichTextEditor.EmojiPicker
        enabled
        onSelect={(emoji) => rte?.addEmoji(emoji)}
      />
    </ActionBar.Secondary>
  </ActionBar>
);
